import React from 'react'
import LoginForm from '../components/auth'
import {register} from "../redux/slices/account";
import {useAppDispatch} from "../redux";
import {useNavigate} from "react-router-dom";
import {Container} from "@mui/material";

export default function Register() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate();

    const onSubmit = async (data: any) => {
        const registerUser = await dispatch(register({
            email: data.email,
            password: data.password,
            passwordConfirmation: data.passwordConfirmation,
            acceptTerms: data.acceptTerms
        }))

        if (!registerUser.payload.errors.length) {
            navigate('/account')
        }
    }

    return (
        <Container>
            <LoginForm form='register' onSubmitForm={onSubmit} />
        </Container>
    )
}
